import styled from 'styled-components';

export const ERROR_SIDEBAR_WIDTH = 320;

export const Body = styled.div`
  margin-top: var(--occurrence-header-offset, 280px);
  height: 100%;
  width: 100%;
  transition: margin-top 200ms ease;
`;

export const ContentLayout = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${props => props.theme.spacing.lg};
  width: 100%;

  @media (max-width: 1200px) {
    flex-direction: column;
  }
`;

export const FormColumn = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Container = styled.div<{
  $withSidebar?: boolean;
}>`
  width: ${props => (props.$withSidebar ? '100%' : '85%')};
  margin: ${props => (props.$withSidebar ? '0' : '0 auto')};
  transition: width 200ms ease, margin 200ms ease;
`;

export const ErrorSidebar = styled.aside`
  width: ${ERROR_SIDEBAR_WIDTH}px;
  flex-shrink: 0;
  position: sticky;
  top: ${props => props.theme.spacing.md};
  margin-top: calc(var(--occurrence-header-offset, 280px) * -1);

  @media (max-width: 1200px) {
    width: 100%;
    position: static;
    margin-top: 0;
  }
`;

export const ErrorSummaryContainer = styled.div`
  padding: ${props => props.theme.spacing.md};
  border-radius: ${props => props.theme.radii.md};
  border: 1px solid ${props => props.theme.colors.danger};
  background-color: ${props => props.theme.colors.rose};
  box-shadow: ${props => props.theme.shadows.xs};
`;

export const ErrorSummaryTitle = styled.p`
  margin: 0 0 ${props => props.theme.spacing.xs} 0;
  font-size: ${props => props.theme.typography.sizes.sm};
  line-height: ${props => props.theme.typography.lineHeights.sm};
  font-weight: ${props => props.theme.typography.weights.semibold};
  color: ${props => props.theme.colors.textPrimary};
`;

export const ErrorSummaryList = styled.ul`
  margin: 0;
  padding-left: ${props => props.theme.spacing.lg};
  display: grid;
  gap: ${props => props.theme.spacing.xxs};
  font-size: ${props => props.theme.typography.sizes.sm};
  line-height: ${props => props.theme.typography.lineHeights.sm};
  color: ${props => props.theme.colors.textSecondary};

  a {
    color: ${props => props.theme.colors.textPrimary};
    text-decoration: underline;
  }

  a:hover {
    color: ${props => props.theme.colors.danger};
  }
`;

export const Title = styled.h1`
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  text-align: center;
  color: #2c3941;
`;

export const FormsSection = styled.section`
  display: flex;
  flex-direction: column;
  padding: 16px;

  :last-child {
    margin-bottom: 16px;
  }
`;
